import React from 'react';
import PropTypes from 'prop-types';

import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

import {Typography} from '~library/atoms/Typography';
import {ResultsCount} from '~/GalleryPB/ResultsCount';

export const PageTitle = (props) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);

  return (
    <Typography
      classNames="gallery__gallery-title"
      variant="header2"
      as="h1"
      data-qa-id="galleryPageTitle"
    >
      {props.text}{' '}
      {largeScreens && props.numTemplates !== null && (
        <ResultsCount numTemplates={props.numTemplates} />
      )}
    </Typography>
  );
};

PageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  numTemplates: PropTypes.number.isRequired,
};
